import { GenericDialog } from '@/components/shared/GenericDialog';
import * as state from '@/state';
import { Button, Stack } from '@mui/material';
import { useCallback } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { ZoneAudit } from './ZoneAudit';

export const ZoneDetailDialog = () => {
  const [open, setOpen] = useAtom(state.showZoneDetailModal);
  const selectedZone = useAtomValue(state.selectedZoneDetails);

  const handleCancel = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  if (!selectedZone) {
    return <></>;
  }

  return (
    <GenericDialog
      open={open}
      dialogStyles={{
        '.MuiDialog-container': {
          alignItems: 'baseline',
          paddingTop: '14.8rem',
        },
      }}
      paperStyles={{
        maxWidth: '65.5rem',
        maxHeight: '58.6rem',
        borderRadius: 0,
      }}
      titleStyles={{
        padding: '3.2rem',
      }}
      onClose={() => setOpen(false)}
      title={selectedZone?.name}
      content={
        <Stack gap="1.6rem">
          <ZoneAudit />
        </Stack>
      }
      actions={
        <Stack
          gap="1.15rem"
          direction="row"
          sx={{
            '.MuiButton-root': {
              padding: '0.6rem 1.6rem',

              fontWeight: 500,
              lineHeight: '2.4rem',
              letterSpacing: '0.04rem',
              fontSize: '1.4rem',
            },
          }}
        >
          <Button variant="contained" sx={{ fontWeight: 500 }} onClick={handleCancel}>
            Close
          </Button>
        </Stack>
      }
      actionsStyles={{ mr: 3, pb: 3, pt: '1.4rem' }}
    />
  );
};
